<template>
  <label class="drag-field"
         @drop.prevent.stop="dropFile"
         @dragleave.stop.prevent="dragLeave"
         @dragenter.stop.prevent="dragEnter"
         :class="{'drug-field_active': enterInField,
            'drug-field_error': typeError}">
    <input type="file"
           @change="changeFile"
           accept="image/*, .doc,.docx,.ppt,.pdf, .xlsx">
    <div class="text-cont">
      <p class="text error" v-if="typeError">{{$t('errors.uploadError')}}</p>
      <p class="text" v-else>{{$t('journal.upload')}}</p>
    </div>
  </label>
</template>

<script>
  export default {
    name: 'uploadEvent',
    data() {
      return {
        typeError: false,
        enterInField: false,
        file: ''
      }
    },
    methods: {
      dropFile(e) {
        let file = e.dataTransfer.files[0];
        this.enterInField = false;
        this.uploadFile(file)
      },
      changeFile(e) {
        let file = e.target.files[0];
        this.uploadFile(file)
      },
      dragLeave() {
        this.enterInField = false
      },
      dragEnter() {
        this.enterInField = true;
        this.typeError = false;
      },
      uploadFile(file) {
        this.typeError = false;

        if (file) {
          this.$emit('upload', [file]);
        };


      }
    },
    mounted() {
      function preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
      }
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        document.addEventListener(eventName, preventDefaults, false)
      })
    }
  }
</script>

<style lang="scss" scoped>


  .controls {
    display: flex;
    align-items: center;
    margin: 0 -5px;

    .control {
      margin: 0 5px;
    }
  }

  .drag-field {
    background: rgba(0, 82, 127, .1);
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100px;
    /*padding-top: 56px;*/
    justify-content: center;
    box-sizing: border-box;
    transition: $anim;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    padding: 30px 0;
    margin-top: 10px;
    color: #00527F;


    img {
      max-width: 61px;
      margin-bottom: 36px;
      opacity: .36;
    }
  }


  .drug-field_error {
    border: 2px dashed $red;
    height: 220px;
    width: 220px;
    cursor: pointer;
  }

  .drug-field_loaded {
    border: none;
    height: 220px;
    width: 220px;
  }

  .drug-field_active {
    border:2px solid rgba(16, 156, 241, .15);
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 2;
      background: rgba(16, 156, 241, .15);
    }
  }


  .text {
    font-family: $mm;
    font-size: 14px;
    letter-spacing: .25px;
    color: #00527F;
    text-align: center;

    span {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .title {
    font-family: $mr;
    font-size: 13px;
    opacity: .5;
    margin: 0;
  }

  .error {
    color: $red;
  }

  input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    z-index: -999;
  }

  .drug-disabled {
    /*.drug-field  img {
      margin-bottom: 0;
    }

    .drug-field {
      padding: 0;
      display: flex;
      justify-content: center;
      align-self: center;
      border: 1px solid $lightBlue;
    }

    .drug-field_loaded {
      border: none;
    }*/

  }
  /*.drug-field {*/
  /*  cursor: pointer;*/
  /*}*/
  .drug-active {
    border: none;
    background-color: rgba(16, 156, 241, .15);
    cursor: pointer;
  }


  .text-cont {
    font-family: $mm;
    padding-left: 14px;
    padding-right: 14px;
    font-size: 12px;
    line-height: 18px;

  }
</style>
